namespace GeniuzPOS.AdvPromo {
    export namespace PsAdvPromoHdAppService {
        export const baseUrl = 'AdvPromo/PsAdvPromoHdApp';

        export declare function Create(request: Serenity.SaveRequest<PsAdvPromoHdAppRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsAdvPromoHdAppRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsAdvPromoHdAppRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsAdvPromoHdAppRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/PsAdvPromoHdApp/Create",
            Update = "AdvPromo/PsAdvPromoHdApp/Update",
            Delete = "AdvPromo/PsAdvPromoHdApp/Delete",
            Retrieve = "AdvPromo/PsAdvPromoHdApp/Retrieve",
            List = "AdvPromo/PsAdvPromoHdApp/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsAdvPromoHdAppService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
